import { Brand } from '@blade/std-lib'

export const TxIdTypeId = 'tradebot-tma/TxId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TxIdTypeId = typeof TxIdTypeId

export type TxId = Brand.Branded<string, TxIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TxId = Brand.nominal<TxId>()
